import { getUTCOffset } from '@/utils/date';

export interface TimeZoneItem {
  timeZone: string;
  zoneCode: string;
  city: string;
  offset: string;
}

const TIMEZONES = [
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Broken_Hill',
  'Australia/Darwin',
  'Australia/Eucla',
  'Australia/Hobart',
  'Australia/Lindeman',
  'Australia/Lord_Howe',
  'Australia/Melbourne',
  'Australia/Perth',
  'Australia/Sydney',
];

/**
 * Get the local time zones for Australia.
 * We don't use the Intl API here because some browsers (Firefox) override these legacy names,
 * while others don't (Safari and Chrome). This inconsistency causes issues with the time zone picker.
 * There are also could be timezones that are deprecated, but still in the tz db to keep backward compatibility.
 * @returns The local time zones for Australia.
 *
 * Example output:
 * [
 *  { timeZone: 'Australia/Adelaide', zoneCode: 'ACDT', city: 'Adelaide', offset: 'GMT+10:30' },
 * ]
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/supportedValuesOf
 */

export const localTimeZomes: TimeZoneItem[] = TIMEZONES.map((timeZone) => {
  const city = timeZone.split('/')[1].replace('_', ' ');
  const offset = getUTCOffset(timeZone, 'shortOffset');
  const zoneCode = getUTCOffset(timeZone, 'short');
  return {
    timeZone,
    zoneCode,
    city,
    offset,
  };
});
